/* eslint-disable react-hooks/exhaustive-deps */
import { Grid, Snackbar, Alert, Box } from "@mui/material";
import * as React from "react";

// helpers
import { getHeaders } from "./../utils/HeaderHelper";
import { AuthenticationContext, ImagesContext } from "../Context";
import ActionHeader from "./ActionHeader";
import GlobalActionQueue from "./global_action_queue/GlobalActionQueue";
import { useFlash } from "../FlashContext";

export type ActionSourceFilterType = "all" | "adt_discharge" | "care_plan";

interface Props {
  csrfToken: string;
  user_id: string;
  action_queue_assign_icon: string;
  action_queue_unassign_icon: string;
  sort_ascending_src: string;
  sort_descending_src: string;
  sort_plain_src: string;
}

const ActionQueue: React.FC<Props> = (props: any) => {
  const [disabledButton, setDisabledButton] = React.useState<boolean>(false);
  const [reloadHook, setReloadHook] = React.useState<boolean>(false);
  const [actionStatuses, setActionStatuses] = React.useState<any>(null);
  const [sourceSummary, setSourceSummary] = React.useState<any>(null);
  const [source, setSource] = React.useState<ActionSourceFilterType>("all");
  const images = React.useContext(ImagesContext);
  const authenticationSetting = React.useContext(AuthenticationContext);
  const [basicInfo, setBasicInfo] = React.useState<any>();
  const [refreshStats, setRefreshStats] = React.useState<boolean>(true);
  const { showToast } = useFlash();

  const getInitialQueueData = () => {
    fetch(`/data_fetching/get_initial_queue_data`, {
      method: "GET",
      headers: getHeaders(authenticationSetting.csrfToken),
    })
      .then((result) => result.json())
      .then((result) => {
        if (typeof result.error !== "undefined") {
          showToast({ title: "Error", text: result.error, type: "error" });
        } else {
          setActionStatuses(Object.keys(result.statuses));
          setSourceSummary(result.source_summary);
        }
      })
      .catch((error) => {
        showToast({ title: "Error", text: "Something went wrong fetching queue data.", type: "error" });
      });
  };

  React.useEffect(() => {
    getInitialQueueData();
  }, []);

  React.useEffect(() => {
    fetch(`/data_fetching/users/basic_user_info/${props.user_id}`, {
      method: "GET",
      headers: getHeaders(authenticationSetting.csrfToken),
    })
      .then((result) => result.json())
      .then((result) => {
        if (result.success == false) {
          console.log(result.message);
        } else {
          setBasicInfo(result?.resource);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }, [props.user_id]);

  return (
    <div className="action-queue">
      <Grid
        container
        direction="row"
        alignItems="flex-start"
        spacing={2}
        className="action-queue-container"
      >
        <Grid item xs={12} pr={"20px"}>
          <ActionHeader basicInfo={basicInfo} refreshData={refreshStats} setRefreshData={setRefreshStats} />
        </Grid>
        <Grid item xs={12} pr={"20px"}>
          <GlobalActionQueue setRefreshStats={setRefreshStats} />
        </Grid>
      </Grid>
    </div>
  );
};

export default ActionQueue;
